export default {
      id: "twitter-usage",
      viewBox: "0 0 512 512",
      url: "../../assets/" + "sprite.svg#twitter-usage",
      toString: function () {
        return this.url;
      }
    }